export default {"src":"/_next/static/media/0x17d8cbb6bce8cee970a4027d1198f6700a7a6c24.28f5ae19.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};